import React from 'react'
import '../styles/ThemeCustomerReviews.css'

const reviews = {
  la: {
    title: {
      fr: 'Ce que les joueurs retiennent',
      en: 'What players remember'
    },
    items: [
      {
        source: 'EscapeGame.fr',
        url: 'https://www.escapegame.fr/paris/one-hour/lost-asylum/',
        highlight: '94%',
        text: {
          fr: 'de satisfaction sur 937 avis joueurs pour Lost Asylum.',
          en: 'satisfaction across 937 player reviews for Lost Asylum.'
        }
      },
      {
        source: 'The Escapers',
        url: 'https://www.the-escapers.com/escape-game/paris/one-hour/lost-asylum',
        highlight: '4,7/5',
        text: {
          fr: 'avec 247 avis et des mentions fortes sur l’immersion.',
          en: 'with 247 reviews and strong mentions for immersion.'
        }
      },
      {
        source: 'Tripadvisor',
        url: 'https://www.tripadvisor.fr/Attraction_Review-g187147-d8843110-Reviews-One_Hour_Live_Escape_Game-Paris_Ile_de_France.html',
        highlight: 'Ambiance',
        text: {
          fr: 'des joueurs parlent d’un décor immersif, d’énigmes bien pensées et d’un vrai jeu d’acteur.',
          en: 'players mention immersive sets, well-designed puzzles and strong live acting.'
        }
      }
    ]
  },
  vbn: {
    title: {
      fr: 'Ce que les joueurs retiennent',
      en: 'What players remember'
    },
    items: [
      {
        source: 'EscapeGame.fr',
        url: 'https://www.escapegame.fr/paris/one-hour/very-bad-night/',
        highlight: '91%',
        text: {
          fr: 'de satisfaction sur 713 avis joueurs pour Very Bad Night.',
          en: 'satisfaction across 713 player reviews for Very Bad Night.'
        }
      },
      {
        source: 'The Escapers',
        url: 'https://www.the-escapers.com/escape-game/paris/one-hour/very-bad-night',
        highlight: '4,4/5',
        text: {
          fr: 'avec 242 avis pour cette salle pensée comme un moment fun et social.',
          en: 'with 242 reviews for this room built as a fun social experience.'
        }
      },
      {
        source: 'The Escapers',
        url: 'https://www.the-escapers.com/blog/paris-city-game',
        highlight: 'Fun',
        text: {
          fr: 'un retour la décrit comme un moment léger, déjanté et accessible entre amis.',
          en: 'one review describes it as a light, offbeat and accessible moment with friends.'
        }
      }
    ]
  },
  abattoir: {
    title: {
      fr: 'Ce que les joueurs retiennent',
      en: 'What players remember'
    },
    items: [
      {
        source: 'EscapeGame.fr',
        url: 'https://www.escapegame.fr/paris/one-hour/abattoir-voltaire/',
        highlight: '96%',
        text: {
          fr: 'de satisfaction sur 926 avis joueurs pour L’Abattoir.',
          en: 'satisfaction across 926 player reviews for L’Abattoir.'
        }
      },
      {
        source: 'The Escapers',
        url: 'https://www.the-escapers.com/escape-game/paris/one-hour',
        highlight: '4,7/5',
        text: {
          fr: 'avec 296 avis et des mentions récurrentes sur l’immersion.',
          en: 'with 296 reviews and recurring mentions for immersion.'
        }
      },
      {
        source: 'Tripadvisor',
        url: 'https://www.tripadvisor.fr/Attraction_Review-g187147-d8843110-Reviews-or10-One_Hour_Live_Escape_Game-Paris_Ile_de_France.html',
        highlight: 'Frissons',
        text: {
          fr: 'les retours soulignent des décors très réalistes et une peur bien présente.',
          en: 'reviews highlight very realistic sets and a strong fear factor.'
        }
      }
    ]
  },
  yakuza: {
    title: {
      fr: 'Ce que les joueurs retiennent',
      en: 'What players remember'
    },
    items: [
      {
        source: 'EscapeGame.fr',
        url: 'https://www.escapegame.fr/paris/one-hour/mission-yakuza/',
        highlight: '94%',
        text: {
          fr: 'de satisfaction sur 783 avis joueurs pour Mission Yakuza.',
          en: 'satisfaction across 783 player reviews for Mission Yakuza.'
        }
      },
      {
        source: 'The Escapers',
        url: 'https://www.the-escapers.com/escape-game/paris/one-hour/mission-yakuza',
        highlight: '4,6/5',
        text: {
          fr: 'avec 348 avis et de nombreux retours sur le game mastering.',
          en: 'with 348 reviews and many mentions of game mastering.'
        }
      },
      {
        source: 'The Escapers',
        url: 'https://www.the-escapers.com/escape-game/paris/one-hour/mission-yakuza',
        highlight: 'Enquête',
        text: {
          fr: 'les joueurs évoquent une vraie enquête policière, dense et immersive.',
          en: 'players describe a genuine, dense and immersive police investigation.'
        }
      }
    ]
  },
  tombeau: {
    title: {
      fr: 'Ce que les joueurs retiennent',
      en: 'What players remember'
    },
    items: [
      {
        source: 'EscapeGame.fr',
        url: 'https://www.escapegame.fr/paris/one-hour/expedition-maudite/',
        highlight: '97%',
        text: {
          fr: 'de satisfaction sur 870 avis joueurs pour L’Expédition Maudite.',
          en: 'satisfaction across 870 player reviews for L’Expédition Maudite.'
        }
      },
      {
        source: 'The Escapers',
        url: 'https://www.the-escapers.com/escape-game/paris/one-hour',
        highlight: '4,7/5',
        text: {
          fr: 'avec 523 avis et une place dans le top parisien The Escapers.',
          en: 'with 523 reviews and a spot in The Escapers Paris ranking.'
        }
      },
      {
        source: 'EscapeGame.fr',
        url: 'https://www.escapegame.fr/paris/one-hour/expedition-maudite/',
        highlight: 'Aventure',
        text: {
          fr: 'la salle est saluée pour ses décors, son rythme et ses mécanismes d’exploration.',
          en: 'the room is praised for its sets, pacing and exploration mechanisms.'
        }
      }
    ]
  }
}

const ThemeCustomerReviews = ({ theme, lang }) => {
  const data = reviews[theme]
  const locale = lang === 'en' ? 'en' : 'fr'

  if (!data) return null

  return (
    <section className="theme-customer-reviews" aria-label={data.title[locale]}>
      <div className="theme-customer-reviews-inner">
        <h2>{data.title[locale]}</h2>
        <div className="theme-customer-reviews-list">
          {data.items.map((item) => (
            <a
              className="theme-customer-review"
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              key={`${theme}-${item.source}-${item.highlight}`}
            >
              <span className="theme-customer-review-source">{item.source}</span>
              <strong>{item.highlight}</strong>
              <span>{item.text[locale]}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  )
}

export default ThemeCustomerReviews



// WEBPACK FOOTER //
// ./src/components/ThemeCustomerReviews.js